import axios, { AxiosError } from 'axios'

export const CANCELLATION_LIMIT_REACHED_INFO = 'cancellation_limit_reached'

interface ApiErrorResponse {
  messages?: Array<{
    info?: string
  }>
}

export function isCancellationLimitReachedError(error: unknown): boolean {
  if (!axios.isAxiosError(error)) return false

  const axiosError = error as AxiosError<ApiErrorResponse>

  return (
    axiosError.response?.status === 405 &&
    axiosError.response?.data?.messages?.[0]?.info === CANCELLATION_LIMIT_REACHED_INFO
  )
}
